(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('input', sc3Digits);

    var isNumber = angular.isNumber;

    sc3Digits.$inject = [];
    function sc3Digits() {
        return {
            restrict: 'E',
            require: '?ngModel',
            link: link
        };

        function link(scope, element, attr, ctrl) {
            var digits;
            if (attr.sc3Digits) {
                if (!ctrl) 
                    throw new Error('ngModel is required when using sc3Digits!');
                digits = parseFloat(attr.sc3Digits) || undefined;
                ctrl.$render = render;
                element.on('blur', render);
                attr.$observe('sc3Digits', digitsWatchAction);
            }

            function digitsWatchAction(val) {
                digits = parseFloat(val) || undefined;
                ctrl.$render();
            }

            function render() {
                var value = isNumber(ctrl.$modelValue) && digits > 0 ? ctrl.$modelValue.toFixed(digits) : ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
                if (element.val() !== value)
                    element.val(value);
            }
        }
    }
})();
